<script setup lang="ts">
import MemberIdentity from "./MemberIdentity.vue";
import MemberRoleMenu from "./MemberRoleMenu.vue";
import MemberSpeckleFlag from "./MemberSpeckleFlag.vue";

// Types
import { UserInProjectType } from "@/features/BuildingProject";

defineProps<{
  user: UserInProjectType;
  selfIsContributer: boolean;
  selfIsAdmin: boolean;
  userImage: string | undefined;
  isSelf: boolean;
  isPending?: boolean;
}>();

const emits = defineEmits<{
  remove: [user: UserInProjectType];
  changeRole: [user: UserInProjectType, newRole: string];
}>();
</script>

<template>
  <!-- Row form of a member, for the wizard's InviteModal.vue, which lists members in three
       role-filtered cards rather than a table. The Manage users dialog composes the same two
       halves into the cells of a Table instead, so the identity and the role control stay shared
       between both surfaces. -->
  <div class="gap-px-12 flex items-center justify-between p-4">
    <div class="gap-px-8 flex min-w-0 items-center">
      <MemberIdentity
        :name="user.name"
        :user-image="userImage"
        :is-self="isSelf" />
      <MemberSpeckleFlag
        v-if="user.speckleStatus === 'noAccount' || user.speckleStatus === 'notOnModel'"
        :status="user.speckleStatus"
        :is-self="isSelf" />
    </div>

    <MemberRoleMenu
      :user="user"
      :self-is-contributer="selfIsContributer"
      :self-is-admin="selfIsAdmin"
      :is-self="isSelf"
      :is-pending="isPending"
      @remove="emits('remove', $event)"
      @change-role="(member, newRole) => emits('changeRole', member, newRole)" />
  </div>
</template>
